import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useReducer
} from 'react';
import {
  selectedPatientAccountingCheckBoxReducer,
  initialSelectedCheckBoxState
} from '@shared/context/reducers/SelectedPatientAccountingReducer';
import {setSelectedPatientAccountingCheckBox} from '@shared/context/actions/SelectedPatientAccountingBoxActions';
import {SelectedPatientAccountingCheckBoxModel} from '@shared/context/mappers/SelectedPatientAccountCheckBoxTypesMapper';

interface SelectedCheckBoxInterface {
  readonly SelectedPatientAccountingCheckBoxState: SelectedPatientAccountingCheckBoxModel;
  readonly setSelectedPatientAccountingCheckBoxData: (data: object) => void;
}

const SelectedCheckBoxContext = createContext<SelectedCheckBoxInterface>(
  {} as SelectedCheckBoxInterface
);

export const useSelectedPatientAccountingCheckBoxContext = (): SelectedCheckBoxInterface =>
  useContext(SelectedCheckBoxContext);

export const SelectedPatientAccountingCheckBoxProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [SelectedPatientAccountingCheckBoxState, dispatch] = useReducer(
    selectedPatientAccountingCheckBoxReducer,
    initialSelectedCheckBoxState
  );

  const setSelectedPatientAccountingCheckBoxData = (data: any): void => {
    setSelectedPatientAccountingCheckBox(dispatch, data);
  };

  return (
    <SelectedCheckBoxContext.Provider
      value={{
        SelectedPatientAccountingCheckBoxState,
        setSelectedPatientAccountingCheckBoxData
      }}>
      {children}
    </SelectedCheckBoxContext.Provider>
  );
};
